export default function Techlogos() {
	return (
		<span>
			<i className="fab fa-react" alt="React" title="React"></i>
			<i className="fab fa-html5" alt="HTML5" title="HTML5"></i>
			<i className="fab fa-css3-alt" alt="SCSS" title="SCSS"></i>
			<i className="fab fa-js-square" alt="JavaScript" title="JavaScript"></i>
			<i className="fab fa-node-js" alt="Node.js" title="Node.js"></i>
		</span>
	);
}
